import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import {BrowserRouter} from 'react-router-dom'
import App from './App';
import { ThemeProvider } from "@mui/material/styles";
import theme from "../src/assets/theme";
import reportWebVitals from './reportWebVitals';
import { MaterialUIControllerProvider } from "./context";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <MaterialUIControllerProvider>
       <ThemeProvider theme={theme}>
    <BrowserRouter>
   <App />
   </BrowserRouter>
   </ThemeProvider>
  </MaterialUIControllerProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
